import type { Store } from '../../../store/player/types';
import { shouldTryNewDimensions } from './shouldTryNewDimensions';

export const handleViewportResizeEvent = (store: Store, event: { w: number; h: number }): void => {
  const { playbackScript, recording } = store.getState();
  if (!recording) return;

  // Do not do the resize if this is not a desktop recording, except if
  // we have crazy dimensions and the incoming ones are less crazy.
  //
  // Resizes in phones and tablets are more complex than we currently cater for.
  // To support them properly we would also need to capture the exact position
  // the viewport is focused on due to zoom-ins and field focus behaviors.
  if (recording.device === 'desktop' || shouldTryNewDimensions(store, event.w, event.h)) {
    recording.window_size = [event.w, event.h];
    playbackScript.adjustRecordingWidth(event.w);
  }
};
